import React from "react";
import styled from "styled-components";
import { CartContext } from "../CartContext";
import { FaTrash } from "react-icons/fa";
import { useContext } from "react";
import { getProductData } from "./productsData";
import { calculateFinalPrice } from "./homeComponents/priceUtils";

const CartProduct = (props) => {
  const cart = useContext(CartContext);
  const id = props.id;
  const quantity = props.quantity;
  const productData = getProductData(id);

  // Find the product in the cart to get its (already correct) line total.
  // Fallback recomputes from the shared pricing rules — never the raw
  // regular price — so a discounted item can't display at full price.
  const cartProduct = cart.items.find((item) => item.id === id);
  const finalPrice =
    cartProduct && cartProduct.finalPrice != null
      ? Number(cartProduct.finalPrice)
      : calculateFinalPrice(
          productData?.name,
          quantity,
          productData?.price,
          productData?.discountPrice,
        );

  return (
    <Container>
      <img className="image" src={productData.image} alt="" />
      <span>
        <h2>
          <span className="cartPSpan">
            <h4>{productData.category}</h4>
            <h3>{productData.name}</h3>
          </span>
          <FaTrash
            onClick={() => cart.deleteFromCart(id)}
            className="deleteIcon"
          />
        </h2>
        <div className="quantity">
          <span className="qty">Sasia: {quantity}</span>
          <h3>{finalPrice.toFixed(2)}€</h3>
        </div>
      </span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  .image {
    height: 120px;
    width: auto;
    border-radius: 0px;
    object-fit: contain;
    background-color: white;
  }
  .cartPSpan {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    gap: 1em;
    h2 {
      width: 100%;
      display: flex;
      span {
        display: flex;
      }
    }
    h4 {
      text-transform: capitalize;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .quantity {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    margin-top: 8px;
    .qty {
      font-size: 14px;
      font-weight: 300;
      color: #c8e6c9;
    }
    h3 {
      font-weight: 500;
      color: #ffffff;
    }
  }
`;

export default CartProduct;
